var PagesModule = (function () {
    function PagesModule() {
    }
    return PagesModule;
}());
export { PagesModule };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/pages.module.ts.pre-build-optimizer.js